import {
    $,
    $e,
    $each,
    init,
    onClickHash,
    vAnim,
    vAnimList,
    vAnimRun,
} from "./cfjs";

init({
    loadedAnimAfter: ".site-header",
    onScrollThrottle: 10,
    preloader: false,
});

vAnimRun(".footer", () => vAnimRun("#start"));


onClickHash(() => {
    bc.remove("menu-active");
});

$e("#menu-toggle", "click", () => {
    bc.toggle("menu-active");
});

const currentLanguageEl = $("#language-select");

function setLanguage(lang) {
    $each(".lang", (el) => {
        const text = el.getAttribute(`data-${lang}`);
        if (text) {
            el.innerHTML = text;
        }
    });
    currentLanguageEl.textContent = lang.toUpperCase();
}

const languages = ["en", "ru", "es"];

function detectBrowserLanguage() {
    const userLang = navigator.language.slice(0, 2).toLowerCase();
    if (languages.includes(userLang)) {
        return userLang;
    }
    return languages[0];
}

setLanguage(detectBrowserLanguage());

$e(".dropdown", "click", ({target}) => {
    target.closest(".dropdown").classList.toggle("active");
});
$e(".dropdown-menu", "click", ({target}) => {
    const lang = target.getAttribute("data-lang");
    if (lang) {
        setLanguage(lang);
    }
});

vAnim(".anim-fade", (el) => {
    el.classList.add("run");
});

vAnimList(".join-list, .steps, .earnings-list, .faq-list, .worker-cards-list");

const getValue = (id) => $('#' + id).value.trim();

const $form = $('#contact-form');

$e($form, 'submit', (e) => {

    e.preventDefault();

    const params = {
        name: getValue("contact-name"),
        phone: getValue('contact-phone'),
        city: getValue("contact-city"),
        language: getValue("contact-language"),
        experience: getValue("contact-experience"),
    }

    fetch('https://api.ozarks-cleaning.com/contacts/cv', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .then(async (v) => {
                const res = await v.json();
                if (res.data === true) {
                    $form.style.display = 'none';
                    $('#success-message').style.display = 'block';
                    $each('#contact>.container>h2, #contact>.container>p:not(#success-message)', el=>{
                        el.style.display = 'none';
                    })
                } else {
                    alert(res.data.errors)
                }
        }).catch((err) => {
        console.log(err);
        alert(err);
    })

})


